import React from 'react'
import { TextField as UITextField } from '@material-ui/core'

const TextField = ({ light, ...props }) => {

  const denseStyle = {
    margin: "dense",
    variant: "filled",
    size: 'small',
    style: {
      background: '#c4c4c4',
      fontWeight: 'bold',
      ...props.style
    }
  }

  const s = light ? {} : denseStyle

  return (
    <UITextField {...props} {...s} />
  )
}

export default TextField